// extracted by mini-css-extract-plugin
module.exports = {"line":"SectionsDivider_line__pD93B","title":"SectionsDivider_title__8KhHE"};